module.exports = __webpack_public_path__ + "media/images/sp/top/soudan_comment-02-26f7b822c79f0bbe3892b20885120488.png";